<script lang="ts">
  import { t } from './i18n.svelte'
  import { onMount } from 'svelte'
  import { getCurrentWindow } from '@tauri-apps/api/window'
  import Brand from './Brand.svelte'
  import { router, navigate } from './router.svelte'
  import { shell } from './shell.svelte'

  /**
   * The desktop window has no native frame (`decorations: false`), so this is
   * its title bar: drag region on the left, the three window buttons on the
   * right. Closing while sharing hides to the tray; the Rust side decides.
   */
  let { title = 'Sofa' }: { title?: string } = $props()

  // Every page except home and the mini window can go back; a live host page cannot.
  const canGoBack = $derived(
    router.current.name !== 'home' &&
      router.current.name !== 'mini' &&
      !(router.current.name === 'host' && shell.hosting),
  )

  const win = getCurrentWindow()
  let maximized = $state(false)

  async function refresh() {
    maximized = await win.isMaximized()
  }

  onMount(() => {
    void refresh()
    const onResize = () => void refresh()
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  })
</script>

<div
  class="titlebar"
  data-tauri-drag-region
  ondblclick={() => win.toggleMaximize()}
  role="presentation"
>
  <div class="titlebar__title" data-tauri-drag-region>
    {#if canGoBack}
      <button
        type="button"
        class="titlebar__back"
        aria-label={t('Back')}
        onclick={() => navigate('/')}
      >
        <svg viewBox="0 0 10 10" aria-hidden="true"><path d="M6.5 1.5 3 5l3.5 3.5" /></svg>
      </button>
    {/if}
    <Brand size={12} wordmark={false} />
    <span data-tauri-drag-region>{title}</span>
  </div>
  <div class="titlebar__buttons">
    <button type="button" aria-label={t('Minimize')} onclick={() => win.minimize()}>
      <svg viewBox="0 0 10 10" aria-hidden="true"><path d="M1 5h8" /></svg>
    </button>
    <button
      type="button"
      aria-label={maximized ? t('Restore') : t('Maximize')}
      onclick={() => win.toggleMaximize()}
    >
      <svg viewBox="0 0 10 10" aria-hidden="true">
        {#if maximized}
          <path d="M2.5 3.5h5.5v5.5H2.5zM4 3.5V1h5v5H8" />
        {:else}
          <rect x="1.5" y="1.5" width="7" height="7" />
        {/if}
      </svg>
    </button>
    <button
      type="button"
      class="titlebar__close"
      aria-label={t('Close')}
      onclick={() => win.close()}
    >
      <svg viewBox="0 0 10 10" aria-hidden="true"><path d="m1 1 8 8M9 1 1 9" /></svg>
    </button>
  </div>
</div>
